"use client";

import ErrorBoundary from "@/components/framework/errorboundary/ErrorBoundary";
import dynamic from 'next/dynamic';
import styles from "./SoMe.module.css";


//#region [Props]
type FacebookProps = {
    value: {
        fbPostUrl: string;
    }
};
//#endregion

//#region [Component]
const DynamicFacebookEmbed = dynamic(() =>
    import('react-social-media-embed').then((mod) => mod.FacebookEmbed),
    { ssr: false }
);

export default function Facebook({ value }: FacebookProps) {
    if (!value?.fbPostUrl) {
        return null;
    }
    return <div className={styles.container}>
        <ErrorBoundary>
            <DynamicFacebookEmbed url={value.fbPostUrl} width="100%" />
        </ErrorBoundary>
    </div>;
}
//#endregion